import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromSelector from './login.selectors';
import * as fromReducer from './login.reducer';
import * as fromActions from './login.actions';
import {
  ILoginForm,
  ISocialLoginForm,
} from '../repositories/ILogin.repository';
import { UserModel } from '../models/user.model';

@Injectable()
export class LoginStore {
  constructor(private store: Store<fromReducer.LoginState>) {}

  get User$() {
    return this.store.select(fromSelector.getUser);
  }

  get success$() {
    return this.store.select(fromSelector.getSuccess);
  }

  get loading$() {
    return this.store.select(fromSelector.getIsLoading);
  }

  get error$() {
    return this.store.select(fromSelector.getError);
  }

  login(credentials: ILoginForm | ISocialLoginForm) {
    this.store.dispatch(fromActions.LoginBeginAction({ credentials }));
  }

  socialLogin(credentials: ISocialLoginForm) {
    this.store.dispatch(fromActions.SocialLoginBeginAction({ credentials }));
  }

  logout() {
    this.store.dispatch(fromActions.LogoutBeginAction());
  }

  setUserData(user: UserModel) {
    this.store.dispatch(fromActions.SetUserData({ user }));
  }
}
